import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import Consultaform from '@/views/Consulta.vue'
import Marcacoes from '@/views/Marcacoes.vue'
import NovoUtente from '@/views/NovoUtente.vue'
import UtenteInfo from "@/views/UtenteInfo.vue"
import Utentes from "@/views/Utentes.vue"
import Terapeutas from "@/views/Terapeutas.vue"
import TerapeutasMapa from "@/views/TerapeutasMapa.vue"
import Timeline from "@/views/Timeline.vue"
import Estatisticas from "@/views/Estatisticas.vue"


Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
    {
      path: "/",
      name: "Login",
      component: Login,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
    },
    {
      path: "/dashboard/marcacao",
      name: "Marcacao",
      component: Consultaform,
    },
    {
      path: "/dashboard/marcacao/:id",
      name: "EditarMarcacao",
      component: Consultaform,
    },
    {
      path: "/dashboard/marcacao/cartao/:id_cartao",
      name: "MarcacaoCartao",
      component: Consultaform,
    },
    {
      path: "/dashboard/consulta/:id/iniciar",
      name: "IniciarConsulta",
      component: Consultaform,
    },
    {
      path: "/dashboard/consulta",
      name: "Consulta",
      component: Consultaform,
    },
    {
      path: "/dashboard/consulta/:id",
      name: "ProcessarConsulta",
      component: Consultaform,
    },
    {
      path: "/utentes/new",
      name: "NovoUtente",
      component: NovoUtente,
    },
    {
      path: "/dashboard/consulta/:id_consulta/marcacoes",
      name: "ProcessarConsultaM",
      component: Marcacoes,
    },
    {
      path: "/dashboard/:id_utente/",
      name: "Utente",
      component: UtenteInfo,
    },
    {
      path: "/utentes/",
      name: "Utentes",
      component: Utentes,
    },
    {
      path: "/utentes/:id_utente",
      name: "ListUtente",
      component: UtenteInfo,
    },
    {
      path: "/terapeutas/",
      name: "Terapeutas",
      component: Terapeutas,
    },
    {
      path: "/terapeutas/mapa/:id_terapeuta",
      name: "TerapeutaMapa",
      component: TerapeutasMapa,
    },
    {
      path: "/terapeutas/timeline/:id_terapeuta",
      name: "Timeline",
      component: Timeline,
    },
    {
      path: "/utentes/marcacoes/editar/:id_consulta",
      name: "EditarMarcacoes",
      component: Marcacoes,
    },
    {
      path: "/utentes/cartao/editar/:id",
      name: "EditarCartao",
      component: Consultaform,
    },
    {
      path: "/utentes/conulta/editar/:id",
      name: "EditarConsulta",
      component: Consultaform,
    },
    {
      path: "/estatisticas/",
      name: "Estatisticas",
      component: Estatisticas,
    },

    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
  ];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
